import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  SimpleChange,
} from '@angular/core';

export interface StarRatings {
  id: number;
  isSelected: boolean;
  isHovered: boolean;
}

@Component({
  selector: 'rx-star-rating',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
})
export class StarRatingComponent implements OnChanges, OnInit {
  /**
   * Maximum number of stars
   */
  @Input() max = 5;
  /**
   * Current selected star
   */
  @Input() currentSelectedStar: number;
  /**
   * Customized label text for each star, showing below the stars
   */
  @Input() messageList = ['Any stars', '2 and up', '3 and up', '4 and up', '5 only'];
  /**
   * On star selection
   */
  @Output() OnRatingChanged = new EventEmitter<StarRatings[]>();
  /**
   * Stars data object (check notes for more info)
   */
  starArray: StarRatings[] = [];
  /**
   * Selected star
   */
  selectedStar: number;
  /**
   * Current message text below the stars
   */
  message: string;

  constructor(private cd: ChangeDetectorRef) {}

  /**
   * Changes listener
   */
  ngOnChanges(changes: SimpleChanges) {
    const messageList: SimpleChange = changes['messageList'];

    if (changes['messageList']) {
      this.messageList = messageList.currentValue;
    }

    const firstSelected = this.starArray.find((star) => star.isSelected);
    if (firstSelected !== undefined) {
      this.setLegend(firstSelected.id);
    } else {
      this.setLegend(1);
    }
    this.cd.markForCheck();
  }

  public ngOnInit() {
    for (let i = 1; i <= this.max; i++) {
      this.starArray.push({
        id: i,
        isSelected: this.currentSelectedStar ? this.currentSelectedStar <= i && this.currentSelectedStar > 1 : false,
        isHovered: false,
      });
    }
    const firstSelected = this.starArray.find((star) => star.isSelected);
    this.setLegend(firstSelected ? firstSelected.id : 1);
  }

  /**
   * On hover
   */
  onHover(val: number) {
    this.selectedStar = this.currentSelectedStar;
    this.currentSelectedStar = val;
    this.starArray.map((data) => {
      data.isSelected = false;
      data.isHovered = data.id >= val;
    });
    const firstHovered = this.starArray.find((star) => star.isHovered);
    this.setLegend(firstHovered.id);
  }

  /**
   * On hover exit
   */
  onHoverOut() {
    this.currentSelectedStar = this.selectedStar;
    this.starArray.map((data) => {
      data.isSelected = data.id >= this.selectedStar && this.selectedStar > 1;
      data.isHovered = false;
    });
    const firstSelected = this.starArray.find((star) => star.isSelected);
    if (firstSelected) {
      this.setLegend(firstSelected.id);
    } else {
      this.setLegend(this.selectedStar);
    }
  }

  /**
   * On star selection
   */
  onSelected(val: number) {
    this.currentSelectedStar = val;
    this.selectedStar = val;

    this.starArray.map((data) => {
      data.isSelected = data.id >= val;
    });
    const firstSelected = this.starArray.find((star) => star.isSelected);
    this.setLegend(firstSelected.id);
    this.OnRatingChanged.emit(this.starArray);
  }

  /**
   * Set message text below the stars
   */
  setLegend(id: number) {
    this.message = this.messageList[id - 1];
  }
}
